/* Bookshelf Walls builder (/pages/build-your-wall) — see snippets/pp-wall-builder.liquid.
   Cart lines use Globo's exact property shape (same as snippets/pp-set-page.liquid), so pricing, the automatic
   "Buy 3 prints, get 20% off" discount and PrintShrimp fulfilment work unchanged. */
(function () {
  var root = document.querySelector('[data-pp-wb]');
  if (!root || root.__ppWb) return; root.__ppWb = true;
  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  // ---------- money: the shopper's currency; Globo add-ons (GBP in GPOConfigs) converted at Shopify's rate ----------
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var R = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
  var money = function (c) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: CUR, currencyDisplay: 'narrowSymbol' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' ' + CUR; }
  };

  // ---------- scale (measured from the size-guide room photo, whose frames are hung to scale) ----------
  var CM = 4.47 / 1536;          // one centimetre as a fraction of the photo's width
  var HW = 2168 / 3072;          // photo height / width
  var BASE_Y = 492 / 1084;       // bottom edge of the hung frames (20 cm above the sofa back), fraction of height
  var MID_X = 751.5 / 1536;      // centre of the sofa, fraction of width
  var GAP = 6, FRAME = 1.2;      // cm between frames; frame profile width in cm
  var PAPER = { A5: [14.8, 21], A4: [21, 29.7], A3: [29.7, 42], A2: [42, 59.4], A1: [59.4, 84.1] };
  var paperCm = function (size) {
    if (PAPER[size]) return PAPER[size];
    var m = /^(\d+)\s*x\s*(\d+)/i.exec(size || '');
    return m ? [m[1] * 2.54, m[2] * 2.54] : [29.7, 42];
  };
  var GRID = { 3: [3, 1], 4: [2, 2], 6: [3, 2] };   // columns, rows

  // Pure layout maths (exported for testing): frame rectangles as % of the room box.
  function layout(n, size, framed) {
    var p = paperCm(size), b = framed ? FRAME : 0;
    var w = p[0] + 2 * b, h = p[1] + 2 * b;
    var g = GRID[n] || [n, 1], cols = g[0], rows = g[1];
    var totalW = cols * w + (cols - 1) * GAP, totalH = rows * h + (rows - 1) * GAP;
    var left0 = MID_X - (totalW * CM) / 2;                 // fractions of width
    var bottom = BASE_Y;                                   // fraction of height
    var top0 = bottom - (totalH * CM) / HW;
    var out = [];
    for (var i = 0; i < n; i++) {
      var c = i % cols, r = Math.floor(i / cols);
      out.push({
        left: (left0 + c * (w + GAP) * CM) * 100,
        top: (top0 + (r * (h + GAP) * CM) / HW) * 100,
        width: w * CM * 100,
        height: (h * CM / HW) * 100,
        border: (b * CM * 100)                              // % of room width
      });
    }
    return { frames: out, tooTall: top0 < 0.01, totalW: totalW, totalH: totalH };
  }
  window.ppWallLayout = layout;

  // ---------- Globo option set (portrait posters: 1479270), same reader as the set page ----------
  var GPO_ID = '1479270', gpoCache = null;
  var readGlobo = function () {
    if (gpoCache) return gpoCache;
    var o = window.GPOConfigs && window.GPOConfigs.options && window.GPOConfigs.options[GPO_ID];
    if (!o) return null;
    var els = [];
    (function walk(a) { a.forEach(function (e) { if (e.elements) walk(e.elements); else els.push(e); }); })(o.elements || []);
    var sizeEl = els.filter(function (e) { return e.label_on_cart === 'Size'; })[0];
    if (!sizeEl) return null;
    var g = { sizes: [], frames: {}, colourKey: 'FrameColor' };
    g.sizes = (sizeEl.option_values || []).map(function (v) { return { value: v.value, price: parseFloat(v.addon_type === 'price' ? v.price : 0) || 0 }; });
    els.forEach(function (e) {
      var vals = e.option_values || [], v0 = vals[0];
      if (vals.some(function (v) { return /^(white|black|wood)$/i.test(v.value || ''); })) { g.colourKey = e.label_on_cart || 'FrameColor'; return; }
      var w = e.clo && e.clo.whens && e.clo.whens[0];
      if (!w || !v0 || !/framed$/i.test(v0.value || '') || w.select !== sizeEl.id) return;
      var vid = v0.addon_type === 'manual_product' ? +(v0.variant_id || 0) : 0;
      g.frames[w.value] = { key: e.label_on_cart, value: v0.value, price: parseFloat(v0.price || v0.variant_price || 0) || 0, vid: vid, ok: v0.addon_type === 'price' || !!vid };
    });
    return (gpoCache = g);
  };

  // ---------- state ----------
  var WALLS = [];
  try { WALLS = JSON.parse(q('[data-pp-wb-walls]').textContent); } catch (e) {}
  var state = { n: 3, slots: [null, null, null], size: 'A3', frame: 'Wood', colour: 'x', wall: '' };
  var cache = {};   // handle -> product data

  var printSrc = function (p, w) {
    var src = p.img || ''; if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    var sep = src.indexOf('?') < 0 ? '?' : '&';
    if (p.tpl) return src + sep + 'width=' + w + '&crop=region&crop_left=557&crop_top=42&crop_width=909&crop_height=1281';
    return src + sep + 'width=' + w;
  };

  var loadProduct = function (handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function (d) {
        var m = (d.media && d.media[0]) || {};
        var p = {
          handle: d.handle, fullTitle: d.title, img: d.featured_image,
          title: d.title.split(' by ')[0].replace(/\s*(Book Watercolour Illustration|Classic Book Art Print|Minimalist Book Poster|Book Cover Poster|Literary Art Print|Bookish Wall Art|Book Watercolour)\s*$/i, '').trim(),
          tpl: m.width === 2048 && m.height === 1366,       // the shared framed template -> exact print crop
          square: m.width === 2048 && m.height === 1196,
          variants: (d.variants || []).map(function (v) { return { id: v.id, title: String(v.title || ''), price: v.price, available: v.available }; })
        };
        cache[handle] = p; return p;
      });
  };

  var pickVariant = function (p) {
    var want = 'STYLE ' + state.colour.toUpperCase();
    var avail = p.variants.filter(function (v) { return v.available; });
    var hit = avail.filter(function (v) { return v.title.toUpperCase() === want; })[0];
    return hit || avail[0] || p.variants[0];
  };
  var hasColours = function () { return state.slots.some(function (p) { return p && p.variants.some(function (v) { return /^STYLE [XYZ]$/i.test(v.title); }); }); };

  // ---------- render ----------
  var setOn = function (sel, attr, val) { qa(sel).forEach(function (b) { var on = b.getAttribute(attr) === String(val); b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); }); };

  var renderFrames = function () {
    var framed = state.frame !== 'none';
    var L = layout(state.n, state.size, framed);
    var box = q('[data-pp-wb-frames]'), roomW = q('[data-pp-wb-room]').clientWidth || 800;
    var cls = framed ? 'pp-wb__fr--' + state.frame.toLowerCase() : 'pp-wb__fr--none';
    var html = '';
    L.frames.forEach(function (f, i) {
      var p = state.slots[i];
      var bw = Math.max(framed ? 1.5 : 0, f.border / 100 * roomW);
      html += '<div class="pp-wb__fr ' + (p ? cls : 'pp-wb__fr--empty') + '" style="left:' + f.left + '%;top:' + f.top + '%;width:' + f.width + '%;height:' + f.height + '%;border-width:' + (p ? bw : 1.5) + 'px">' +
        (p ? '<img alt="" src="' + printSrc(p, roomW > 700 ? 500 : 300) + '">' : '') + '</div>';
    });
    box.innerHTML = html;
    var dims = Math.round(L.totalW) + ' × ' + Math.round(L.totalH) + ' cm';
    q('[data-pp-wb-cap]').textContent = L.tooTall
      ? 'This wall (' + dims + ') is taller than the space above this sofa. Try a smaller size or a row of 3.'
      : 'Shown to scale above a 2.2 m sofa. The whole wall is about ' + dims + '.';
  };

  var renderSlots = function () {
    var ol = q('[data-pp-wb-slots]'), html = '';
    for (var i = 0; i < state.n; i++) {
      var p = state.slots[i];
      html += '<li class="pp-wb__slot">' + (p
        ? '<img alt="" src="' + printSrc(p, 120) + '"><span class="pp-wb__slot-t">' + escapeHtml(p.title) + '</span><button type="button" class="pp-wb__x" data-pp-wb-remove="' + i + '" aria-label="Remove ' + escapeHtml(p.title) + '">×</button>'
        : '<span class="pp-wb__slot-empty"></span><span class="pp-wb__slot-t is-empty">Empty — search below to add a book</span><span></span>') + '</li>';
    }
    ol.innerHTML = html;
  };

  var renderSizes = function () {
    var g = readGlobo(), box = q('[data-pp-wb-sizes]');
    if (!g) { box.innerHTML = '<p class="pp-wb__note">Loading sizes…</p>'; return; }
    if (!g.sizes.some(function (s) { return s.value === state.size; })) state.size = (g.sizes[0] || {}).value || 'A5';
    var rowA = '', rowI = '';
    g.sizes.forEach(function (s) {
      var m = /^(\d+)\s*x\s*(\d+)/i.exec(s.value), short = m ? m[1] + '×' + m[2] + '″' : s.value;
      var pc = paperCm(s.value), dim = Math.round(pc[0]) + ' × ' + Math.round(pc[1]) + ' cm';
      var b = '<button type="button" class="pp-wb__sz' + (s.value === state.size ? ' is-on' : '') + '" data-size="' + s.value.replace(/"/g, '&quot;') + '"><b>' + short + '</b><span>' + dim + '</span></button>';
      if (m) rowI += b; else rowA += b;
    });
    var inchFirst = window.Shopify && /^(US|CA)$/.test(Shopify.country || '');
    var a = rowA ? '<div class="pp-wb__sizerow">' + rowA + '</div>' : '', i = rowI ? '<div class="pp-wb__sizerow pp-wb__sizerow--in">' + rowI + '</div>' : '';
    box.innerHTML = inchFirst ? i + a : a + i;
  };

  var lineCents = function (p, g) {
    var v = pickVariant(p), c = v ? v.price : 0;
    if (g) {
      var sz = g.sizes.filter(function (s) { return s.value === state.size; })[0]; if (sz) c += Math.round(sz.price * R * 100);
      var fr = g.frames[state.size]; if (state.frame !== 'none' && fr && fr.ok) c += Math.round(fr.price * R * 100);
    }
    return c;
  };

  var renderPrice = function () {
    var g = readGlobo(), filled = state.slots.filter(Boolean);
    var fr = g && g.frames[state.size], canFrame = !!(fr && fr.ok);
    var note = q('[data-pp-wb-frame-note]');
    if (state.frame !== 'none' && g && !canFrame) { note.hidden = false; note.textContent = 'Frames aren’t available in this size, so these prints will come unframed.'; }
    else note.hidden = true;
    var total = 0; filled.forEach(function (p) { total += lineCents(p, g); });
    var off = filled.length >= 3 ? Math.floor(total * 0.2) : 0;
    q('[data-pp-wb-now]').textContent = filled.length ? money(total - off) : '—';
    q('[data-pp-wb-was]').textContent = off ? money(total) : '';
    var left = 3 - filled.length;
    q('[data-pp-wb-save]').textContent = off ? 'You save ' + money(off) + ' with Buy 3 prints, get 20% off'
      : (filled.length ? 'Add ' + left + ' more print' + (left > 1 ? 's' : '') + ' for 20% off' : '');
    var add = q('[data-pp-wb-add]');
    add.disabled = !filled.length;
    add.textContent = filled.length ? 'Add wall to basket · ' + money(total - off) : 'Add wall to basket';
    q('[data-pp-wb-colour]').closest('.pp-wb__step').hidden = !hasColours();
  };

  var render = function () {
    setOn('[data-pp-wb-layouts] [data-n]', 'data-n', state.n);
    setOn('[data-pp-wb-frame] [data-f]', 'data-f', state.frame);
    setOn('[data-pp-wb-colour] [data-c]', 'data-c', state.colour);
    qa('[data-pp-wb-wall]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-pp-wb-wall') === state.wall); });
    renderFrames(); renderSlots(); renderSizes(); renderPrice();
  };

  var escapeHtml = function (t) { return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var setN = function (n) {
    state.n = n;
    var s = state.slots.filter(Boolean).slice(0, n);
    while (s.length < n) s.push(null);
    state.slots = s;
  };

  var loadWall = function (key) {
    var w = WALLS.filter(function (x) { return x.key === key; })[0]; if (!w) return;
    state.wall = key;
    var n = w.handles.length >= 6 ? 6 : (w.handles.length >= 4 ? 4 : 3);
    state.n = n; state.slots = new Array(n).fill(null);
    render();
    w.handles.slice(0, n).forEach(function (h, i) {
      loadProduct(h).then(function (p) { if (state.wall === key) { state.slots[i] = p; render(); } }).catch(function () {});
    });
  };

  var addToSlot = function (p) {
    if (p.square) { flash('Square prints can’t be mixed into this wall yet. Try the same book in another style.'); return; }
    var i = state.slots.indexOf(null);
    if (i < 0) {
      if (state.n < 6) { setN(state.n === 3 ? 4 : 6); i = state.slots.indexOf(null); }
      else { flash('Your wall is full. Remove a print to swap it.'); return; }
    }
    state.slots[i] = p; state.wall = ''; render();
  };

  var flash = function (msg) {
    var ul = q('[data-pp-wb-results]'); ul.hidden = false; ul.innerHTML = '<li class="is-msg">' + escapeHtml(msg) + '</li>';
    setTimeout(function () { if (ul.querySelector('.is-msg')) ul.hidden = true; }, 3500);
  };

  // ---------- search ----------
  var qInput = q('[data-pp-wb-q]'), results = q('[data-pp-wb-results]'), qTimer = null, qSeq = 0;
  qInput.addEventListener('input', function () {
    clearTimeout(qTimer);
    var term = qInput.value.trim();
    if (term.length < 2) { results.hidden = true; return; }
    qTimer = setTimeout(function () {
      var my = ++qSeq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (my !== qSeq) return;
          var items = (((d || {}).resources || {}).results || {}).products || [];
          items = items.filter(function (p) { return !/literary art print/i.test(p.title); });   // Square style
          results.hidden = false;
          results.innerHTML = items.length ? items.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || '';
            return '<li><button type="button" data-pp-wb-pick="' + escapeHtml(p.handle) + '">' +
              (img ? '<img alt="" src="' + img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=96&crop=region&crop_left=557&crop_top=42&crop_width=909&crop_height=1281">' : '<span></span>') +
              '<span>' + escapeHtml(p.title) + '</span></button></li>';
          }).join('') : '<li class="is-msg">No posters found. Try an author or another title.</li>';
        }).catch(function () {});
    }, 280);
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('.pp-wb__search')) results.hidden = true; });

  // ---------- clicks ----------
  root.addEventListener('click', function (e) {
    var b;
    if ((b = e.target.closest('[data-pp-wb-wall]'))) { loadWall(b.getAttribute('data-pp-wb-wall')); return; }
    if ((b = e.target.closest('[data-pp-wb-layouts] [data-n]'))) { setN(+b.getAttribute('data-n')); state.wall = ''; render(); return; }
    if ((b = e.target.closest('[data-pp-wb-frame] [data-f]'))) { state.frame = b.getAttribute('data-f'); render(); return; }
    if ((b = e.target.closest('[data-pp-wb-colour] [data-c]'))) { state.colour = b.getAttribute('data-c'); render(); return; }
    if ((b = e.target.closest('[data-size]'))) { state.size = b.getAttribute('data-size'); render(); return; }
    if ((b = e.target.closest('[data-pp-wb-remove]'))) { state.slots[+b.getAttribute('data-pp-wb-remove')] = null; state.wall = ''; render(); return; }
    if ((b = e.target.closest('[data-pp-wb-pick]'))) {
      results.hidden = true; qInput.value = '';
      loadProduct(b.getAttribute('data-pp-wb-pick')).then(addToSlot).catch(function () { flash('Sorry, that poster couldn’t be loaded.'); });
      return;
    }
    if ((b = e.target.closest('[data-pp-wb-add]'))) addWall(b);
  });

  // ---------- add to basket (Globo's exact line shape, as on the set page) ----------
  var addWall = function (btn) {
    var g = readGlobo() || { sizes: [], frames: {}, colourKey: 'FrameColor' };
    var sz = g.sizes.filter(function (s) { return s.value === state.size; })[0] || { price: 0 };
    var fr = g.frames[state.size];
    var framed = state.frame !== 'none' && fr && fr.ok;
    var group = String(Date.now()), items = [];
    var wallName = (WALLS.filter(function (w) { return w.key === state.wall; })[0] || {}).name || 'Custom wall';
    state.slots.forEach(function (p, i) {
      if (!p) return;
      var v = pickVariant(p); if (!v) return;
      var opts = { _has_gpo: GPO_ID, Size: state.size };
      var addons = [], extra = null, pg = group + i;
      if (sz.price) addons.push({ i: null, q: 1, p: sz.price.toFixed(2), t: 'price' });
      if (fr) {
        opts[fr.key] = framed ? fr.value : 'No Frame';
        if (framed) {
          opts[g.colourKey] = state.frame;
          if (fr.vid) extra = { id: fr.vid, quantity: 1, properties: { _gpo_parent_product_group: pg, _gpo_field_name: fr.key } };
          else addons.push({ i: null, q: 1, p: fr.price.toFixed(2), t: 'price' });
        }
      }
      var props = Object.assign({}, opts, { _gpo_product_group: pg, _wall: wallName });
      if (addons.length) { props._gpo_options = JSON.stringify(opts); props._gpo_addon_products = JSON.stringify(addons); }
      items.push({ id: v.id, quantity: 1, properties: props });
      if (extra) items.push(extra);
    });
    if (!items.length) return;
    btn.disabled = true; q('[data-pp-wb-err]').hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('pp:cart-updated'));
        if (window.ppCartDrawer && window.ppCartDrawer.enabled && window.ppCartDrawer.enabled()) window.ppCartDrawer.open(true);
        else window.location.href = '/cart';
      })
      .catch(function () { btn.disabled = false; q('[data-pp-wb-err]').hidden = false; });
  };

  // ---------- start ----------
  window.addEventListener('resize', function () { renderFrames(); });
  var start = new URLSearchParams(location.search).get('wall');
  if (start && WALLS.some(function (w) { return w.key === start; })) loadWall(start);
  else if (WALLS[0]) loadWall(WALLS[0].key);
  else render();
  // Globo's config can arrive after this script: re-render sizes/prices once it exists.
  var tries = 0, iv = setInterval(function () { if (readGlobo() || ++tries > 40) { clearInterval(iv); render(); } }, 250);
})();
